/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 * Web App Entry Point
 */
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

//Entry Container <App>
import App from 'containers/app/App';
import * as serviceWorker from 'serviceWorker';
import 'typeface-roboto';

// Root Store
import { rootStore, StoreProvider } from 'stores/RootStore';

//Initialize Sentry Monitoring
if (process.env.REACT_APP_SENTRY === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    enabled: process.env.REACT_APP_SENTRY,
    debug: false,
    environment: process.env.NODE_ENV,
  });
}

ReactDom.render(
  <Provider store={rootStore} {...rootStore}>
    <StoreProvider {...rootStore}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MuiPickersUtilsProvider>
    </StoreProvider>
  </Provider>,
  document.getElementById('root')
);

// Register ServiceWorker
serviceWorker.register();
